'use client';

interface AmountSectionProps {
  amount: number | null | undefined;
  label?: string | null;
  currency?: string;
}

export function AmountSection({ amount, label, currency = 'USD' }: AmountSectionProps) {
  if (amount == null) {
    return null;
  }

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

  return (
    <div className="p-3 rounded-lg bg-card border border-border">
      {label && (
        <div className="text-[10px] text-muted-foreground font-semibold tracking-wider mb-1">
          {label}
        </div>
      )}
      <div className="text-lg font-semibold text-success">
        {formatted}
      </div>
    </div>
  );
}
